export default __webpack_public_path__ + "static/media/hostBannerDefault.9293d45d.jpeg";